/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {OvertimeReportByTimecardRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {OvertimeReportByTimecardResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const overtimeReportByTimecard = (request: OvertimeReportByTimecardRequest, options?: CashRequestOptions) => post<OvertimeReportByTimecardRequest, OvertimeReportByTimecardResponse>("/proxy/services/squareup.timecards.TimeCalculationReportService/OvertimeReportByTimecard", request, {...options, rejectOnError: true })